module.exports = __webpack_public_path__ + "img/39000.6e59000a.jpg";